export default {
    cn: {
        commissionTable: {
            relationshipListReport: '关系图报表',
            isSetting: {
                allStatus: '全部状态',
                sated: '已设定',
                checked: '已审核',
                unchecked: '未审核',
                unsated: '未设定'

            },
            ibStatus: {
                enable: '启用',
                disenable: '禁用'
            },
            ibSpecialType: {
                all: '全部',
                special: '特殊返佣',
                normal: '普通返佣'
            },
            ibTempOverwriteType: ['未改写模版','已改写模版','全部'],
            ibreport: {
                text: '已激活代理报表',
                ibAccountText: '代理账号：',
                statusText: '状态：',
                statusList: { "-1": "全部", "0": "已激活", "1": "未激活", "2": "不活跃", "3": "已关闭" }
            },
            ibTh: [
                { key: 'IB_ID', name: '代理的账号', sort: true },
                { key: 'NAME', name: '代理姓名', sort: true },
                { key: 'status', name: '状态', sort: true },
                { key: 'FIRST_REBATE_TIME', name: '激活时间', sort: true, changeTime: true },
                { key: 'LAST_REBATE_TIME', name: '最后收取佣金时间', sort: true, changeTime: true }
            ],
            showName: '显示名字',
            th: {
                settingStatus: '设定状态',
                IBgroup: '组别',
                specialCommission: '特殊返佣',
                loginId: "登录账号",
                ibcAccount: "收佣账号",
                IBCode: "IB代码",
                accountName: "账户名称",
                phone: "电话",
                email: "电子邮箱",
                updateBy: "修改人",
                confirmBy: "审核人",
                template: "模版",
                remark: "备注",
                last_update: "最后修改时间",
                status: "状态",
                officeState: {
                    name: "职员状态",
                    countryArr: [
                        { text: "全职", value: "F" },
                        { text: "兼职", value: "P" },
                        { text: "离职", value: "D" }
                    ]
                },
                employeeState: {
                    F: '全职',
                    P: '兼职',
                    D: '离职'
                },
                loginType: {
                    name: "类型",
                    typeArr: [
                        { text: '系统', value: "UN" },
                        { text: '公司', value: "C" },
                        { text: '国家', value: "N" },
                        { text: '地区', value: "R" },
                        { text: '办事处', value: "O" },
                        { text: '经理', value: "M" },
                        { text: '销售', value: "SL" },
                        { text: '代理', value: "IB" },
                        { text: '客户', value: "CL" },
                    ],
                    roleType: {
                        UN: '系统',
                        UPUN1: '上层系统',
                        UPUN2: '上层系统',
                        UPUN3: '上层系统',
                        UPUN4: '上层系统',
                        UPUN5: '上层系统',
                        UPUN6: '上层系统',
                        UPUN7: '上层系统',
                        UPUN8: '上层系统',
                        UPUN9: '上层系统',
                        UPUN10: '上层系统',
                        C: '公司',
                        UPC1: "上层公司",
                        UPC2: "上层公司",
                        UPC3: "上层公司",
                        UPC4: "上层公司",
                        UPC5: "上层公司",
                        UPC6: "上层公司",
                        UPC7: "上层公司",
                        UPC8: "上层公司",
                        UPC9: "上层公司",
                        UPC10: "上层公司",
                        N: '国家',
                        UPN1: "上层国家",
                        UPN2: "上层国家",
                        UPN3: "上层国家",
                        UPN4: "上层国家",
                        UPN5: "上层国家",
                        UPN6: "上层国家",
                        UPN7: "上层国家",
                        UPN8: "上层国家",
                        UPN9: "上层国家",
                        UPN10: "上层国家",
                        R: '地区',
                        UPR1: '上层地区',
                        UPR2: '上层地区',
                        UPR3: '上层地区',
                        UPR4: '上层地区',
                        UPR5: '上层地区',
                        UPR6: '上层地区',
                        UPR7: '上层地区',
                        UPR8: '上层地区',
                        UPR9: '上层地区',
                        UPR10: '上层地区',
                        O: '办事处',
                        UPO1: '上层办事处',
                        UPO2: '上层办事处',
                        UPO3: '上层办事处',
                        UPO4: '上层办事处',
                        UPO5: '上层办事处',
                        UPO6: '上层办事处',
                        UPO7: '上层办事处',
                        UPO8: '上层办事处',
                        UPO9: '上层办事处',
                        UPO10: '上层办事处',
                        M: '经理',
                        UPM1: '上层经理',
                        UPM2: '上层经理',
                        UPM3: '上层经理',
                        UPM4: '上层经理',
                        UPM5: '上层经理',
                        UPM6: '上层经理',
                        UPM7: '上层经理',
                        UPM8: '上层经理',
                        UPM9: '上层经理',
                        UPM10: '上层经理',
                        SL: '销售',
                        UPSL1: '上级销售',
                        UPSL2: '上级销售',
                        UPSL3: '上级销售',
                        UPSL4: '上级销售',
                        UPSL5: '上级销售',
                        UPSL6: '上级销售',
                        UPSL7: '上级销售',
                        UPSL8: '上级销售',
                        UPSL9: '上级销售',
                        UPSL10: '上级销售',
                        IB: '代理',
                        UPIB1: '上级代理',
                        UPIB2: '上级代理',
                        UPIB3: '上级代理',
                        UPIB4: '上级代理',
                        UPIB5: '上级代理',
                        UPIB6: '上级代理',
                        UPIB7: '上级代理',
                        UPIB8: '上级代理',
                        UPIB9: '上级代理',
                        UPIB10: '上级代理',
                        CL: '客户',
                        TD:"交易账号",
                    }
                },
                operation: "操作"
            },
            clauses_text: "显示条目数",
            all: "全部",
            amount: "总数",
            present: "当前",
            refreshData: "全部数据",
            downloadExcelForms: "下载Excel",
            search: "搜索",
            nodata: "没有查询到数据",
            ibcAccount: "收佣账号",
            modifyTime: "修改时间",
            confirmTime: "审核时间",
        }
    },
    hk: {
        commissionTable: {
            relationshipListReport: '關系圖報表',
            isSetting: {
                allStatus: '全部狀態',
                sated: '已設定',
                checked: '已審核',
                unchecked: '未審核',
                unsated: '未設定'
            },
            ibStatus: {
                enable: '啟用',
                disenable: '禁用'
            },
            ibSpecialType: {
                all: '全部',
                special: '特殊返佣',
                normal: '普通返佣'
            },
            ibTempOverwriteType: ['未改写模版','已改写模版','全部'],
            ibreport: {
                text: '已激活代理報表',
                ibAccountText: '代理賬號：',
                statusText: '狀態：',
                statusList: { "-1": "全部", "0": "已激活", "1": "未激活", "2": "不活躍", "3": "已關閉" }
            },
            ibTh: [
                { key: 'IB_ID', name: '代理的賬號', sort: true },
                { key: 'NAME', name: '代理姓名', sort: true },
                { key: 'status', name: '狀態', sort: true },
                { key: 'FIRST_REBATE_TIME', name: '激活時間', sort: true, changeTime: true },
                { key: 'LAST_REBATE_TIME', name: '最後收取佣金時間', sort: true, changeTime: true }
            ],
            showName: '顯示名字',
            th: {
                settingStatus: '設定狀態',
                IBgroup: '組別',
                specialCommission: '特殊返佣',
                loginId: "登錄賬號",
                ibcAccount: "收佣賬號",
                IBCode: "IB代碼",
                accountName: "帳戶名稱",
                phone: "電話",
                email: "電子郵箱",
                updateBy: "修改人",
                confirmBy: "審核人",
                template: "模版",
                remark: "備註",
                last_update: "最後修改時間",
                status: "狀態",
                officeState: {
                    name: "職員狀態",
                    countryArr: [
                        { text: "全職", value: "F" },
                        { text: "兼職", value: "P" },
                        { text: "離職", value: "D" }
                    ]
                },
                employeeState: {
                    F: '全職',
                    P: '兼職',
                    D: '離職'
                },
                loginType: {
                    name: "類型",
                    typeArr: [
                        { text: '系統', value: "UN" },
                        { text: '公司', value: "C" },
                        { text: '國家', value: "N" },
                        { text: '地區', value: "R" },
                        { text: '辦事處', value: "O" },
                        { text: '經理', value: "M" },
                        { text: '銷售', value: "SL" },
                        { text: '代理', value: "IB" },
                        { text: '客戶', value: "CL" },
                    ],
                    roleType: {
                        UN: '系統',
                        UPUN1: "上級系統",
                        UPUN2: "上級系統",
                        UPUN3: "上級系統",
                        UPUN4: "上級系統",
                        UPUN5: "上級系統",
                        UPUN6: "上級系統",
                        UPUN7: "上級系統",
                        UPUN8: "上級系統",
                        UPUN9: "上級系統",
                        UPUN10: "上級系統",
                        C: '公司',
                        UPC1: "上級公司",
                        UPC2: "上級公司",
                        UPC3: "上級公司",
                        UPC4: "上級公司",
                        UPC5: "上級公司",
                        UPC6: "上級公司",
                        UPC7: "上級公司",
                        UPC8: "上級公司",
                        UPC9: "上級公司",
                        UPC10: "上級公司",
                        N: '國家',
                        UPN1: "上級國家",
                        UPN2: "上級國家",
                        UPN3: "上級國家",
                        UPN4: "上級國家",
                        UPN5: "上級國家",
                        UPN6: "上級國家",
                        UPN7: "上級國家",
                        UPN8: "上級國家",
                        UPN9: "上級國家",
                        UPN10: "上級國家",
                        R: '地區',
                        UPR1: "上級地區",
                        UPR2: "上級地區",
                        UPR3: "上級地區",
                        UPR4: "上級地區",
                        UPR5: "上級地區",
                        UPR6: "上級地區",
                        UPR7: "上級地區",
                        UPR8: "上級地區",
                        UPR9: "上級地區",
                        UPR10: "上級地區",
                        O: '辦事處',
                        UPO1: '上級辦事處',
                        UPO2: '上級辦事處',
                        UPO3: '上級辦事處',
                        UPO4: '上級辦事處',
                        UPO5: '上級辦事處',
                        UPO6: '上級辦事處',
                        UPO7: '上級辦事處',
                        UPO8: '上級辦事處',
                        UPO9: '上級辦事處',
                        UPO10: '上級辦事處',
                        M: '經理',
                        UPM1: '上級經理',
                        UPM2: '上級經理',
                        UPM3: '上級經理',
                        UPM4: '上級經理',
                        UPM5: '上級經理',
                        UPM6: '上級經理',
                        UPM7: '上級經理',
                        UPM8: '上級經理',
                        UPM9: '上級經理',
                        UPM10: '上級經理',
                        SL: '銷售',
                        UPSL1: '上級銷售',
                        UPSL2: '上級銷售',
                        UPSL3: '上級銷售',
                        UPSL4: '上級銷售',
                        UPSL5: '上級銷售',
                        UPSL6: '上級銷售',
                        UPSL7: '上級銷售',
                        UPSL8: '上級銷售',
                        UPSL9: '上級銷售',
                        UPSL10: '上級銷售',
                        IB: '代理',
                        UPIB1: '上級代理',
                        UPIB2: '上級代理',
                        UPIB3: '上級代理',
                        UPIB4: '上級代理',
                        UPIB5: '上級代理',
                        UPIB6: '上級代理',
                        UPIB7: '上級代理',
                        UPIB8: '上級代理',
                        UPIB9: '上級代理',
                        UPIB10: '上級代理',
                        CL: '客戶',
                        TD:'交易賬號',
                    }
                },
                operation: "操作"
            },
            clauses_text: "顯示條目數",
            all: "全部",
            amount: "總數",
            present: "當前",
            refreshData: "全部數據",
            downloadExcelForms: "下載Excel",
            search: "搜索",
            nodata: "没有查询到数据",
            ibcAccount: "收佣賬號",
            modifyTime: "修改時間",
            confirmTime: "審核時間",
        }
    },
    en: {
        commissionTable: {
            relationshipListReport: 'Relationship List Report',
            isSetting: {
                allStatus: 'All Status',
                sated: 'Configured',
                checked: 'Checked',
                unchecked: 'Unchecked',
                unsated: 'Unconfigured'
            },
            ibStatus: {
                enable: 'Enable',
                disenable: 'Disable'
            },
            ibSpecialType: {
                all: 'All',
                special: 'special',
                normal: 'normal'
            },
            ibTempOverwriteType: ['Not Overwritten','Overwritten','All'],
            ibreport: {
                text: 'Activated IB Report',
                ibAccountText: 'IB Account：',
                statusText: 'Status：',
                statusList: { "-1": "All", "0": "Activated", "1": "Inactive", "2": "Non-Activated", "3": "Closed" }
            },
            ibTh: [
                { key: 'IB_ID', name: 'IB Account', sort: true },
                { key: 'NAME', name: 'IB Name', sort: true },
                { key: 'status', name: 'Status', sort: true },
                { key: 'FIRST_REBATE_TIME', name: 'Activation Time', sort: true, changeTime: true },
                { key: 'LAST_REBATE_TIME', name: 'Last Rebate Time', sort: true, changeTime: true }
            ],
            showName: 'Show Name',
            th: {
                settingStatus: 'Setting Status',
                IBgroup: 'Group',
                specialCommission: 'Special',
                loginId: "Login Account",
                ibcAccount: "Commission Account",
                IBCode: "IB Code",
                accountName: "Account Name",
                phone: "Phone",
                email: "Email",
                updateBy: "Update By",
                confirmBy: "Confirm By",
                template: "Template",
                remark: "Remark",
                last_update: "Last Modification ",
                status: "Status",
                officeState: {
                    name: "Employee Status",
                    countryArr: [
                        { text: "full time", value: "F" },
                        { text: "part time", value: "P" },
                        { text: "Leave", value: "D" }
                    ]
                },
                employeeState: {
                    F: 'full time',
                    P: 'part time',
                    D: 'Leave'
                },
                loginType: {
                    name: "Types of",
                    typeArr: [
                        { text: 'SYSTEM', value: "UN" },
                        { text: 'COMPANY', value: "C" },
                        { text: 'COUNTRY', value: "N" },
                        { text: 'REGION', value: "R" },
                        { text: 'OFFICE', value: "O" },
                        { text: 'MANAGER', value: "M" },
                        { text: 'SALES', value: "SL" },
                        { text: 'IB', value: "IB" },
                        { text: 'cCLIENT', value: "CL" },
                    ],
                    roleType: {
                        UN: 'SYSTEM',
                        UPUN1:'UPPER SYSTEM',
                        UPUN2: 'UPPER SYSTEM',
                        UPUN3: 'UPPER SYSTEM',
                        UPUN4: 'UPPER SYSTEM',
                        UPUN5: 'UPPER SYSTEM',
                        UPUN6: 'UPPER SYSTEM',
                        UPUN7: 'UPPER SYSTEM',
                        UPUN8: 'UPPER SYSTEM',
                        UPUN9: 'UPPER SYSTEM',
                        UPUN10: 'UPPER SYSTEM',
                        C: 'COMPANY',
                        UPC1:"UPPER COMPANY",
                        UPC2: "UPPER COMPANY",
                        UPC3: "UPPER COMPANY",
                        UPC4: "UPPER COMPANY",
                        UPC5: "UPPER COMPANY",
                        UPC6: "UPPER COMPANY",
                        UPC7: "UPPER COMPANY",
                        UPC8: "UPPER COMPANY",
                        UPC9: "UPPER COMPANY",
                        UPC10: "UPPER COMPANY",
                        N: 'COUNTRY',
                        UPN1:"UPPER COUNTRY",
                        UPN2: "UPPER COUNTRY",
                        UPN3: "UPPER COUNTRY",
                        UPN4: "UPPER COUNTRY",
                        UPN5: "UPPER COUNTRY",
                        UPN6: "UPPER COUNTRY",
                        UPN7: "UPPER COUNTRY",
                        UPN8: "UPPER COUNTRY",
                        UPN9: "UPPER COUNTRY",
                        UPN10: "UPPER COUNTRY",
                        R: 'REGION',
                        UPR1: 'UPPER REGION',
                        UPR2: 'UPPER REGION',
                        UPR3: 'UPPER REGION',
                        UPR4: 'UPPER REGION',
                        UPR5: 'UPPER REGION',
                        UPR6: 'UPPER REGION',
                        UPR7: 'UPPER REGION',
                        UPR8: 'UPPER REGION',
                        UPR9: 'UPPER REGION',
                        UPR10: 'UPPER REGION',
                        O: 'OFFICE',
                        UPO1: 'UPPER OFFICE',
                        UPO2: 'UPPER OFFICE',
                        UPO3: 'UPPER OFFICE',
                        UPO4: 'UPPER OFFICE',
                        UPO5: 'UPPER OFFICE',
                        UPO6: 'UPPER OFFICE',
                        UPO7: 'UPPER OFFICE',
                        UPO8: 'UPPER OFFICE',
                        UPO9: 'UPPER OFFICE',
                        UPO10: 'UPPER OFFICE',
                        M: 'MANAGER',
                        UPM1: 'UPPER MANAGER',
                        UPM2: 'UPPER MANAGER',
                        UPM3: 'UPPER MANAGER',
                        UPM4: 'UPPER MANAGER',
                        UPM5: 'UPPER MANAGER',
                        UPM6: 'UPPER MANAGER',
                        UPM7: 'UPPER MANAGER',
                        UPM8: 'UPPER MANAGER',
                        UPM9: 'UPPER MANAGER',
                        UPM10: 'UPPER MANAGER',
                        SL: 'SALES',
                        UPSL1: 'UPPER SALES',
                        UPSL2: 'UPPER SALES',
                        UPSL3: 'UPPER SALES',
                        UPSL4: 'UPPER SALES',
                        UPSL5: 'UPPER SALES',
                        UPSL6: 'UPPER SALES',
                        UPSL7: 'UPPER SALES',
                        UPSL8: 'UPPER SALES',
                        UPSL9: 'UPPER SALES',
                        UPSL10: 'UPPER SALES',
                        IB: 'IB',
                        UPIB1: 'UPPER IB',
                        UPIB2: 'UPPER IB',
                        UPIB3: 'UPPER IB',
                        UPIB4: 'UPPER IB',
                        UPIB5: 'UPPER IB',
                        UPIB6: 'UPPER IB',
                        UPIB7: 'UPPER IB',
                        UPIB8: 'UPPER IB',
                        UPIB9: 'UPPER IB',
                        UPIB10: 'UPPER IB',
                        CL: 'CLIENT',
                        TD:"Trading Account",
                    }
                },
                operation: "Operation"
            },
            clauses_text: "Display",
            all: "All",
            amount: " Total Count",
            present: "Current",
            refreshData: "Refresh Data",
            downloadExcelForms: "Download Excel",
            search: "Search",
            nodata: "No data found",
            ibcAccount: "Commission Account",
            modifyTime: "Mofify Time",
            confirmTime: "Confirm Time",
        }
    }
};



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/commissionTable.js